import React from "react";
import { HashRouter as Router, Route, Routes } from "react-router-dom";
import ImportFile from "./components/ImportFile";
import ProductComparisonSummary from "./components/ProductComparisonSummary";
import EndPage from "./components/EndReport";

const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route path="/EP" element={<EndPage />} />
        <Route path="/PCS" element={<ProductComparisonSummary />} />
        <Route path="/" element={<ImportFile />} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
